import { forwardRef } from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface OtpInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  autoFocus?: boolean;
  onComplete?: (value: string) => void;
  className?: string;
  ariaLabel?: string;
}

export const OtpInput = forwardRef<HTMLInputElement, OtpInputProps>(
  function OtpInput(
    { value, onChange, disabled, autoFocus, onComplete, className, ariaLabel },
    ref,
  ) {
    return (
      <Input
        ref={ref}
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={6}
        autoComplete="one-time-code"
        autoFocus={autoFocus}
        disabled={disabled}
        aria-label={ariaLabel ?? "Verification code"}
        value={value}
        onChange={(e) => {
          const next = e.target.value.replace(/\D/g, "").slice(0, 6);
          onChange(next);
          if (next.length === 6) onComplete?.(next);
        }}
        className={cn(
          "h-14 rounded-xl border-slate-200 bg-white text-center font-mono text-2xl tracking-[0.5em] [letter-spacing:0.5em]",
          className,
        )}
      />
    );
  },
);
